import React, { Component } from 'react';
import { connect } from 'react-redux';
import FordCalendar from '../utility/FordCalendar';
import Button from '../utility/Button';
import PaxSelector from '../utility/PaxSelector';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';
import { withTranslation } from 'react-i18next';

import { setBookingPax } from '../../actions/booking';
import { toggleSelectByor } from '../../actions/tripDetails';
import CustomCheckbox from '../utility/CustomCheckbox';

import {
  getPricePerPax,
  getDiscPricePerPax,
  createPriceLabel,
  calcTripPrice,
  calcTripDiscountedPrice,
  parseMoney,
  capitalise,
  getCurrentPaxPrice,
  findMinMaxPaxRate
} from '../../js/utility';

class TripMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null
    };

    this.lockRef = React.createRef();

    this.handleSelect = this.handleSelect.bind(this);
    this.validatePax = this.validatePax.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isActive } = this.props;
    if (prevProps.isActive !== isActive) {
      if (isActive) {
        disableBodyScroll(this.lockRef.current);
      } else {
        enableBodyScroll(this.lockRef.current);
      }
    }
    if (prevProps.bookingPax === 0 && this.state.error) {
      this.setState({
        error: null
      });
    }

  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  handleSelect({ neutral, adult, child }) {
    const { tripPax, t } = this.props;
    const { pax_min } = tripPax;

    if (typeof neutral !== 'undefined') {
      this.props.setBookingPax(neutral);
    } else {
      this.props.setBookingPax({ adult, child });
    }

    const total = typeof neutral === 'undefined' ? adult + child : neutral;

    this.setState({
      error: total >= pax_min ? null : t('error:minPax', { min: pax_min })
    });
  }

  validatePax() {
    if (this.state.error === null) {
      this.props.history.push(`/booking/${this.props.match.params.slug}`);
    }
  }

  render() {
    const {
      isMobile,
      currentTrip,
      bookingPax,
      isActive,
      btnText,
      btnBack,
      t,
      isByAge,
      isByPax,
      tripPax,
      byorSelected,
      toggleSelectByor
    } = this.props;

    let menuClass = 'fe-menu';

    if (isMobile) {
      menuClass = menuClass.concat('-mobile');
    }
    if (isActive) {
      menuClass = menuClass.concat(' active');
    }
    const { pax_min, current_pax_max } = tripPax;
    const tripDiscount = currentTrip.trip_discount;

    if (!current_pax_max){
      // reset pax
      this.props.setBookingPax(0);
    }

    const isPerTrip = currentTrip.trip_price.is_per_trip;

    let tourPrice = calcTripPrice(currentTrip.trip_price, bookingPax);

    let discountedTourPrice = calcTripDiscountedPrice(
      currentTrip.trip_price,
      bookingPax,
      currentTrip.trip_discount
    );

    let pricePerPax = getPricePerPax(currentTrip.trip_price, tripPax);
    const discPricePerPax = getDiscPricePerPax(
      currentTrip.trip_price,
      tripPax,
      currentTrip.trip_discount
    );

    const lowestAdultPax = findMinMaxPaxRate(currentTrip.trip_price.adult_rate, 'min');
    const lowestChildPax = (currentTrip.trip_price.child_rate) ? findMinMaxPaxRate(currentTrip.trip_price.child_rate, 'min') : 0;
    const totalPax = (bookingPax.adult) ? (bookingPax.adult + bookingPax.child) : bookingPax;

    // Include insurance, SST, & service fee
    const insurance = parseFloat(process.env.INSURANCE_AMOUNT);
    const sstPercentage = parseFloat(process.env.TAX_PERCENTAGE)/100;
    const serviceFee = parseFloat(process.env.SST_PERCENTAGE)/100;
    pricePerPax.adult = pricePerPax.adult + (insurance * lowestAdultPax);
    pricePerPax.adult = pricePerPax.adult + (pricePerPax.adult * serviceFee);
    pricePerPax.adult = pricePerPax.adult + (pricePerPax.adult * sstPercentage);
    if (lowestChildPax > 0){
      pricePerPax.child = pricePerPax.child + (insurance * lowestChildPax);
      pricePerPax.child = pricePerPax.child + (pricePerPax.child * serviceFee);
      pricePerPax.child = pricePerPax.child + (pricePerPax.child * sstPercentage);
    }
    if (tourPrice){
      tourPrice = tourPrice + (insurance * totalPax);
      tourPrice = tourPrice + (tourPrice * serviceFee);
      tourPrice = tourPrice + (tourPrice * sstPercentage);
    }
    if (discountedTourPrice){
      discountedTourPrice = discountedTourPrice + (insurance * totalPax);
      discountedTourPrice = discountedTourPrice + (discountedTourPrice * serviceFee);
      discountedTourPrice = discountedTourPrice + (discountedTourPrice * sstPercentage);
    }

    let priceStr = createPriceLabel(pricePerPax, discPricePerPax);
    const pricePerPaxEqual = createPriceLabel(pricePerPax.adult / pax_min);
    let perPaxOnly = true;
    const separatedPrice = [];

    if (currentTrip.slug === 'ford-ranger-training-experience-sabah'){
      priceStr.adult = 'From ' + priceStr.adult + ' per vehicle';
      separatedPrice.push(priceStr.adult);
      if (priceStr.child){
        priceStr.child = 'From ' + priceStr.child + ' per vehicle';
        separatedPrice.push(priceStr.child);
        perPaxOnly = false;
      }
    }
    else if (currentTrip.slug === 'a-trip-through-nature-at-gunung-jerai'){
      priceStr.adult = 'From ' + priceStr.adult + '<br> (Up to 4 pax)';
      separatedPrice.push(priceStr.adult);
      if (priceStr.child){
        priceStr.child = 'From ' + priceStr.child + '<br> (Up to 3 pax)';
        separatedPrice.push(priceStr.child);
        perPaxOnly = false;
      }
    }
    else if (isByPax) {
      priceStr = (arr => {
        if (arr.length > 1) perPaxOnly = false;

        const ret = [];
        for (const [key, val] of arr) {
          switch (key) {
            case 'adult':
              if (arr.length > 1) {
                // adult price if min != max and child present
                ret[0] = `${capitalise(t(`gen:${key}`))} from ${val}`;
                separatedPrice[0] = ret[0];
                break;
              } else if (pax_min == current_pax_max) {
                // adult price if min = max with no child present
                ret[0] = `${
                  t('gen:fromPricePerGuest', {
                    price: pricePerPaxEqual
                  })
                }`;
                separatedPrice[0] = ret[0];
                break;
              } else {
                // adult price if min != max with no child present
                ret[0] = `${
                  t('gen:fromPricePerGuest', { price: priceStr.adult })
                }`;
                separatedPrice[0] = ret[0];
                break;
              }
            case 'child':
              ret[1] = `${t(`gen:${key}`)} from ${val}`;
              separatedPrice[1] = `${capitalise(t(`gen:${key}`))} from ${val}`;
              break;
          }
        }

        return ret.join(', ');
      })(Object.entries(priceStr));
    }

    return (
      <div ref={this.lockRef} className={menuClass}>
        <div className='fe-menu-content'>
          <div className='fe-menu-heading-container mobile'>
            <h4 className='fe-menu-heading'>{t('gen:dateSelection')}</h4>
          </div>
          <div className='fe-menu-calendar'>
            <FordCalendar />
          </div>
          <div className='fe-menu-legend'>
            <div className='fe-menu-legend-item'>
              <span className='fe-menu-legend-color avail' />
              <span className='fe-menu-legend-text'>{t('gen:availDates')}</span>
            </div>
            <div className='fe-menu-legend-item'>
              <span className='fe-menu-legend-color unavail' />
              <span className='fe-menu-legend-text'>{t('gen:soldOutNA')}</span>
            </div>
            {/* <div className='fe-menu-legend-note'>
              *{t('trip:advBookingNote')}
            </div> */}
          </div>
          <div className='fe-menu-booking-info'>
            <PaxSelector
              isByAge={isByAge}
              isByPax={isByPax}
              value={bookingPax}
              min={pax_min}
              max={current_pax_max}
              onChange={this.handleSelect}
              perPaxOnly={perPaxOnly}
              trip_price={currentTrip.trip_price}
              separatedPrice={separatedPrice}
            >
              {/* {isPerTrip && !isByPax ? null : (
                <span
                  className='fe-menu-text'
                  dangerouslySetInnerHTML={{
                    __html: priceStr
                  }}
                />
              )} */}
            </PaxSelector>

            {/* {currentTrip.byor && (
              <div className='fe-menu-booking-byor-section'>
                <label className='fe-form-checkbox-container'>
                  <input
                    type='checkbox'
                    checked={byorSelected}
                    onChange={() => {
                      toggleSelectByor();
                    }}
                    disabled
                  />
                  <span className={`fe-form-checkbox`} />
                  Bring your own Ranger
                </label>
              </div>
            )} */}
          </div>

          {currentTrip.promocode ? (
            <div className='fe-menu-total'>
              <div className="promocode-section">
                <span className='fe-menu-promo-text'>Use the promo code when you check out!</span>
                <div>
                  <span className="fe-menu-promo-available">
                    Promo Code Available:
                  </span>
                  <span className="fe-menu-promocode">
                    {' ' + currentTrip.promocode}
                  </span>
                </div>
              </div>
            </div>)
            : null}

          <div className='fe-menu-total'>
            <span className='fe-menu-total-text'>{t('gen:totalPrice')}</span>
            <span className='fe-menu-total-price'>
              RM{' '}
              {tripDiscount
                ? parseMoney(discountedTourPrice)
                : parseMoney(tourPrice)}
            </span>
          </div>

          <div className='fe-menu-confirm'>
            <span className='fe-form-error'>{this.state.error}</span>
            <Button
              disabled={!!this.state.error || !currentTrip.available_dates.length}
              showLoader={false}
              onClick={this.validatePax}
            >
              {t(btnText)}
            </Button>
            <Button
              className={'fe-menu-btn-back alt ' + (isMobile ? 'show' : '')}
              showLoader={false}
              onClick={this.props.onMenuClose}
            >
              {t(btnBack)}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

TripMenu.propTypes = {
  match: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  slug: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  currentTrip: PropTypes.object.isRequired,
  bookingPax: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
    .isRequired,
  setBookingPax: PropTypes.func.isRequired,
  toggleSelectByor: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  btnText: PropTypes.string.isRequired,
  btnBack: PropTypes.string.isRequired,
  onMenuClose: PropTypes.func,
  t: PropTypes.func.isRequired,
  tripPax: PropTypes.object.isRequired,
  isByAge: PropTypes.bool.isRequired,
  byorSelected: PropTypes.bool.isRequired
};

TripMenu.defaultProps = {
  isMobile: false,
  slug: '',
  btnText: 'gen:bookNow',
  btnBack: 'gen:goBack',
  isActive: false
};

const mapStateToProps = ({ tripDetailsState, bookingState }) => ({
  currentTrip: tripDetailsState.currentTrip,
  date: bookingState.date,
  bookingPax: bookingState.pax,
  tripPax: tripDetailsState.pax,
  isByAge: tripDetailsState.isByAge,
  isByPax: tripDetailsState.isByPax,
  byorSelected: tripDetailsState.byorSelected
});

const mapDispatchToProps = {
  setBookingPax,
  toggleSelectByor
};

export default withRouter(
  withTranslation()(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(TripMenu)
  )
);
